import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15c2141b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, " This process is used to bulk match and market property details to contacts via email. Each email sent will count as 1 credit. ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "count-title" }, "Number of Contacts to be processed:", -1))
const _hoisted_3 = { class: "count-fields" }

import { computed, ref, inject, onMounted, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import LookupSingleSelect from "./ui/lookup/lookup-single-select.vue";
import { BranchEmailTemplateFilters } from "@/types/BranchEmailTemplateFilters";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import { MassMarketingRecord } from "@/types/MassMarketingRecord";
import SingleSelect from "./ui/dropdowns/single-select.vue";
import { FieldSize } from "@/enums/system/FieldSize";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";
import { standardInfoAlert } from "@/alerts/standardInfoAlert";
import { displayQuestionAlert } from "@/alerts/questionAlert";
import AcquaintInfoBox from "./ui/inputs/acquaint-info-box.vue";
import NewEditEmailTemplatesModal from "./email/new-edit-email-templates-modal.vue";
import { MassApplicantCount } from "@/types/MassApplicantCount";


export default /*#__PURE__*/_defineComponent({
  __name: 'match-marketing-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const apiNextClient = inject("AcquaintApiNextClient") as AcquaintApiNextClient;

const currentUserStore = useCurrentUserStore();
const currentUserDetails = ref<CurrentUser>();
const matchMarketRecords = ref<MassMarketingRecord[]>([]);
const fields = ref<BranchEmailTemplateFilters>({
  branchId: -1,
  emailTemplatedId: -1,
});
const credits = ref(0);
const emailTemplates = ref<IDDescriptionPair[]>([]);
const displayTemplateModal = ref(false);
const applicantCount = ref<MassApplicantCount>({
  salesContacts: 0,
  lettingsContacts: 0,
});

onMounted(async () => {
  currentUserDetails.value = await currentUserStore.getCurrentUserDetails();
  fields.value.branchId = currentUserDetails.value?.siteID ?? -1;
});

const sendEmails = async () => {
  try {
    matchMarketRecords.value = await apiNextClient.httpPost(
      "/MatchAndMarkets",
      fields.value,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    matchMarketRecords.value = [];
  }
};

const checkEmailSubmissionSuccess = async () => {
  const sendConfirmationAlert = await displayQuestionAlert(
    "Are you sure you want to send these emails?",
  );

  if (!sendConfirmationAlert.isConfirmed) {
    return;
  }

  await sendEmails();

  if (matchMarketRecords.value.length == 0) {
    return;
  }

  const successConfirmationAlert = await standardInfoAlert(
    "Your Property Bulletin Emails are being queued and will be sent shortly.",
  );

  if (
    successConfirmationAlert.isConfirmed ||
    successConfirmationAlert.isDismissed
  ) {
    showModal.value = false;
  }
};

watch(
  () => showModal.value,
  () => {
    if (!showModal.value) {
      return;
    }
    fetchEmailTemplates();
    getEmailCredits();
    fetchContactCount();
  },
);

const fetchEmailTemplates = async () => {
  try {
    emailTemplates.value = await apiNextClient.httpGet<IDDescriptionPair[]>(
      `MatchAndMarkets/AllBulletinEmailTemplates`,
    );
  } catch (err) {
    emailTemplates.value = [];
  }
};

const getEmailCredits = async () => {
  try {
    credits.value = await apiNextClient.httpGet("/Email/getemailcreditbalance");
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    credits.value = 0;
  }
};

const fetchContactCount = async () => {
  try {
    applicantCount.value = await apiNextClient.httpGet<MassApplicantCount>(
      `MatchAndMarkets/contacts/count?siteId=${fields.value.branchId}`,
    );
  } catch (err) {
    applicantCount.value = {
      salesContacts: 0,
      lettingsContacts: 0,
    };
    displayErrorMessage(getErrorMessage(err));
  }
};

watch(
  () => fields.value.branchId,
  () => {
    if (!showModal.value) {
      return;
    }

    fetchContactCount();
  },
);

const onCancelClick = () => (showModal.value = false);

const modalHeight = computed(() => {
  return window.innerWidth < 768 ? "450px" : "400px";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showModal).value = $event)),
      title: "Match Properties",
      showCloseConfirmationPrompt: false,
      height: modalHeight.value,
      "help-page": "match-and-marketing"
    }, {
      content: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(AcquaintInfoBox, {
            text: applicantCount.value.lettingsContacts.toString(),
            label: "Lettings",
            width: _unref(FieldSize).Small
          }, null, 8, ["text", "width"]),
          _createVNode(AcquaintInfoBox, {
            text: applicantCount.value.salesContacts.toString(),
            label: "Sales",
            width: _unref(FieldSize).Small
          }, null, 8, ["text", "width"]),
          _createVNode(AcquaintInfoBox, {
            text: credits.value.toString(),
            label: "Email Credits",
            width: _unref(FieldSize).Small
          }, null, 8, ["text", "width"])
        ]),
        _createVNode(LookupSingleSelect, {
          label: "Branch",
          modelValue: fields.value.branchId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fields.value.branchId) = $event)),
          "lookup-source": _unref(LookupTableSource).Sites,
          showClearButton: true,
          allowZeroValue: true
        }, null, 8, ["modelValue", "lookup-source"]),
        _createVNode(SingleSelect, {
          label: "Property Bulletin Template",
          modelValue: fields.value.emailTemplatedId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fields.value.emailTemplatedId) = $event)),
          "data-source": emailTemplates.value,
          showClearButton: true,
          width: _unref(FieldSize).Full
        }, null, 8, ["modelValue", "data-source", "width"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "before",
          options: {
          text: 'View Template',
          onClick: () => {
            displayTemplateModal.value = true;
          },
          disabled: fields.value.emailTemplatedId == -1,
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Send Emails',
          onClick: () => {
            checkEmailSubmissionSuccess();
          },
          disabled: fields.value.emailTemplatedId == -1,
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "height"]),
    _createVNode(NewEditEmailTemplatesModal, {
      modelValue: displayTemplateModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((displayTemplateModal).value = $event)),
      configurationId: fields.value.emailTemplatedId
    }, null, 8, ["modelValue", "configurationId"])
  ], 64))
}
}

})